import React, {Component} from 'react';
import $ from 'jquery';
import Banner from '../view/Banner';
import Steps from '../view/Steps';
import Contracts from '../view/Contracts';
import RecentArticles from '../view/RecentArticles';
import Bottom from '../view/Bottom';
import Meta from '../model/Meta';

class Home extends Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	render() {
		const meta = {
			title: "Create and customize fast and easy contracts",
			description: "Create and customize fast and easy contracts free"
		}
		
		return (
			<div className="page">
				<Meta {...meta} />
					<Banner />
					<Steps />
					<Contracts />
					<RecentArticles />
					<Bottom />
			</div>
		);
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js